export const MARKETING = {
      productName: 'Workflow Automation',
      tagline: 'Workflow-driven WhatsApp & Voice Automation',
      subTagline:
        'Run real business processes with deterministic workflows, async execution, and zero hallucinations.',
      demoUrl: 'https://wa.me/XXXXXXXXXX',
      docsUrl: '/how-it-works',
      contactEmail: 'sales@yourdomain.com'
    };